import 'scss/solutions/AI-media-cloud-solution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/AI-media-cloud-solution.js